import { useCustomQuery } from '../../graphql';

export const useAssetRoutines = (
  workspaceAssetId: string | undefined,
  workspaceRoutineId: string | undefined,
  resetDate?: string
) => {
  if (!workspaceAssetId || !workspaceRoutineId) {
    return {
      assetRoutinesCount: { count: 0 },
    };
  }

  const { data: completionCount, isLoading } = useCustomQuery({
    cacheKey: ['assetRoutineCompletionCount', workspaceAssetId, workspaceRoutineId, resetDate],
    query: FIND_ASSET_ROUTINES,
    variables: {
      workspaceAssetId: workspaceAssetId,
      routineId: workspaceRoutineId,
      resetDate: resetDate,
    },
  });

  return {
    isLoading,
    assetRoutinesCount: { count: completionCount?.asset?.getAssetRoutineCompletionCount || 0 },
  };
};

const FIND_ASSET_ROUTINES = `
  query GetAssetRoutineCompletionCount($workspaceAssetId: String!, $routineId: String!, $resetDate: String) {
    asset {
      getAssetRoutineCompletionCount(workspaceAssetId: $workspaceAssetId, routineId: $routineId, resetDate: $resetDate)
    }
  }
`;
